import { ActionTree, ActionContext } from "vuex/types";
import State from "./state";
import RootState from '../../state';
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import memberInteriorSettingsService from '../../../services/memberInteriorSettingsService';
import { SET_MEMBER_INTERIOR_SETTINGS_DATA } from "./mutation-types";
import { ISettingsCardAddEditOutput } from "../../../models/interfaces/memberInteriorSettings/iSettingsCardAddEditOutput";
import { IUpdatedPasswordOutput } from "../../../models/interfaces/memberInteriorSettings/iUpdatedPasswordOutput";
import { IPasswordEditOutput } from "../../../models/interfaces/memberInteriorSettings/iPasswordEditOutput";
import { IAccountIntegrationOutputData } from "../../../models/interfaces/memberInteriorSettings/iAccountIntegrationOutputData";
import { AccountIntegrations } from "../../../models/enums/accountIntegrations";
import { IAccountIntegration } from "../../../models/interfaces/memberInteriorSettings/iAccountIntegration";

const actions: ActionTree<State, RootState> = {
	async getMemberInteriorSettingsData({ commit }: ActionContext<State, RootState>): Promise<any> {
		const { data } = await memberInteriorSettingsService.getMemberInteriorSettingsData();
		const result = camelizer.convert(data);
        //debugger;
		commit(SET_MEMBER_INTERIOR_SETTINGS_DATA, result);

		return result;
	},

	async updateInteriorSettingsData({ commit }: ActionContext<State, RootState>, settingsData: ISettingsCardAddEditOutput): Promise<any> {
		const { data } = await memberInteriorSettingsService.updateInteriorSettingsData(settingsData);
		const result = camelizer.convert(data);

		commit(SET_MEMBER_INTERIOR_SETTINGS_DATA, result);

		return result;
	},

	async updateMemberPassword({ commit }: ActionContext<State, RootState>, passwordData: IUpdatedPasswordOutput): Promise<any> {
		const result = await memberInteriorSettingsService.updateMemberPassword(passwordData);

		return result;
	},

	async updateEmailNotifications({ commit }: ActionContext<State, RootState>, notificationsData: IPasswordEditOutput[]): Promise<any> {
		const result = await memberInteriorSettingsService.updateEmailNotifications(notificationsData);

		return result;
    },

    async updateMemberDataThroughLinkedIn({ commit, state }: ActionContext<State, RootState>, accountIntegrationOutputData: IAccountIntegrationOutputData): Promise<any> {
        //debugger;
        const result = await memberInteriorSettingsService.updateMemberDataThroughLinkedIn(accountIntegrationOutputData);
        //debugger;
        state.settings.accountIntegrations = state.settings.accountIntegrations.map((accountIntegration: IAccountIntegration) => {
            if (accountIntegration.type == AccountIntegrations.LinkedIn)
            {
                accountIntegration.firstName = accountIntegrationOutputData.firstNameLinkedIn;
                accountIntegration.lastName = accountIntegrationOutputData.lastNameLinkedIn;
                accountIntegration.profileUrl = accountIntegrationOutputData.profileUrlLinkedIn;
            }

            return accountIntegration;
        })

        return result;
    },
};

export default actions;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/memberInteriorSettings/actions.ts